import React from 'react';
import {
  takeEvery,
  getContext,
  put,
  takeLatest,
  select,
} from 'redux-saga/effects';
import { getNotificationService } from '@erecruit/modules';
import {
  showNotification,
  closeNotification,
  notificationContainerRef,
} from '@erecruit/ui-kit';

import {
  ShowAction,
  notificationActions,
  FetchHistoryAction,
  MarkAsReadAction,
  notificationSelectors,
  GetUnreadNotificationsAction,
} from './reducer';
import { BasicNotification } from '../components';
import { AppNotification } from '../types';
import { PAGE_SIZE } from '../helpers';

function* showNotifications(action: ShowAction) {
  const { dispatch } = yield getContext('store');
  action.payload.forEach(notification =>
    showNotification(
      <BasicNotification
        title={notification.title}
        body={notification.body}
        type={notification.type}
        link={notification.link}
        time={notification.createdOn}
        read={notification.read}
        onOkClick={() =>
          dispatch(notificationActions.markAsRead(notification.id))
        }
      />,
      {
        toastId: notification.id,
        onOpen: () => {
          const toasts: string[] = notificationContainerRef.current
            ? notificationContainerRef.current.state.toast
            : [];
          toasts.forEach((notificationId, index) => {
            // TODO - move notification limit to settings
            if (toasts.length - index > 5) {
              closeNotification(notificationId);
            }
          });
        },
      },
    ),
  );
}

function* getNotificationHistory(action: FetchHistoryAction) {
  const mappedEntries = yield getNotificationService().getHistory(
    action.payload,
  );

  if (mappedEntries.length === 0) {
    yield put(notificationActions.setFullHistoryLoaded());
  } else {
    yield put(notificationActions.addToHistory(mappedEntries));
  }

  yield put(notificationActions.fetchHistorySuccess());
}

function* fetchUnreadNotificationsCount() {
  const unreadCount = yield getNotificationService().getUnreadCount();
  yield put(notificationActions.setUnreadCount(unreadCount));
}

function* markNotificationAsRead(action: MarkAsReadAction) {
  const notificationId = action.payload;
  yield getNotificationService().markNotificationsAsRead([notificationId]);
}

function* markAllNotificationsRead() {
  const unreadNotifications: AppNotification[] = yield select(
    notificationSelectors.getUnread,
  );
  const unreadNotificationIds = unreadNotifications.map(
    notification => notification.id,
  );
  yield getNotificationService().markNotificationsAsRead(unreadNotificationIds);
  yield put(notificationActions.markAllAsReadSuccess());
}

function* fetchUnreadNotifications(action: GetUnreadNotificationsAction) {
  const mappedEntries = yield getNotificationService().getUnread(
    action.payload,
  );

  if (mappedEntries.length === 0) {
    yield put(notificationActions.setFullUnreadLoaded());
  } else {
    yield put(notificationActions.getUnreadNotificationsSuccess(mappedEntries));

    if (mappedEntries.length < PAGE_SIZE) {
      yield put(notificationActions.setFullUnreadLoaded());
    }
  }
}

function* watchForNotification() {
  yield takeEvery('notifications/push', showNotifications);
  yield takeLatest('notifications/fetchHistory', getNotificationHistory);
  yield takeLatest(
    'notifications/getUnreadCount',
    fetchUnreadNotificationsCount,
  );
  yield takeLatest('notifications/markAsRead', markNotificationAsRead);
  yield takeLatest('notifications/markAllAsRead', markAllNotificationsRead);
  yield takeLatest(
    'notifications/getUnreadNotifications',
    fetchUnreadNotifications,
  );
}

export default [watchForNotification()];
